/**
 * Normalised application error surfaced by the API client's response
 * interceptor.  Hooks expose `error: AppError | null` so pages can render
 * `<PageError>` without inspecting Axios internals.
 */
export class AppError extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly statusCode?: number,
  ) {
    super(message);
    this.name = 'AppError';
  }
}

/** True for the statuses that mean "you lack the entitlement", not "it broke". */
export function isAccessDeniedStatus(statusCode: number | undefined): boolean {
  return statusCode === 401 || statusCode === 403;
}

export function isAccessDeniedError(err: unknown): boolean {
  return err instanceof AppError && isAccessDeniedStatus(err.statusCode);
}
